import { useMemo } from "react";

import type { IFilterManagerModel } from "app/pages/sales-intelligence/modules/advanced-search-filtering/services/filters-manager/types";
import type { IPlainObject } from "app/pages/sales-intelligence/types/plainObject";

import type { SavedSearchViewModel } from "../types/view-model";
import { getDirtyFilterKeys } from "../utils/dirty-filters";

type Params<T extends IPlainObject> = {
    filtersManager: IFilterManagerModel<T>;
};

export const useSavedSearchViewModel = <T extends IPlainObject = IPlainObject>({
    filtersManager,
}: Params<T>): SavedSearchViewModel<T> => {
    const dirtyFilterKeys = useMemo(() => getDirtyFilterKeys(filtersManager), [filtersManager]);

    return { dirtyFilterKeys, areFiltersDirty: dirtyFilterKeys.length > 0 };
};
